/**
 * 可控下拉菜单的选项式api
 */
export const useControllableDropdown = () => {
  const visible = ref(false)

  const setVisible = (state: boolean) => {
    visible.value = state
  }

  return [visible, setVisible] as const
}
